import { SVGProps } from "react";

const AlertIcon = (props: SVGProps<SVGSVGElement>) => {
  const { color, ...rest } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="alertIconTitle"
      {...rest}
    >
      <title id="alertIconTitle">Alert</title>
      <path d="M9.23544 17.4709C13.7837 17.4709 17.4709 13.7837 17.4709 9.23544C17.4709 4.68713 13.7837 1 9.23544 1C4.68713 1 1 4.68713 1 9.23544C1 13.7837 4.68713 17.4709 9.23544 17.4709Z" stroke={color ?? "#71717A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21 21.0002L15.1176 15.1178" stroke={color ?? "#71717A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.9173 5.6633L8.97606 9.93146L6.51494 7.47033L3.74609 10.2391" stroke={color ?? "#71717A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.2643 11.2851C14.2643 12.1918 13.6296 12.6451 12.8752 12.9081C12.8357 12.9214 12.7928 12.9208 12.7537 12.9062C11.9975 12.6451 11.3629 12.1918 11.3629 11.2851V10.0157C11.3629 9.96757 11.382 9.92145 11.416 9.88744C11.45 9.85343 11.4961 9.83433 11.5442 9.83433C11.9069 9.83433 12.3602 9.61672 12.6758 9.34108C12.7142 9.30826 12.7631 9.29022 12.8136 9.29022C12.8641 9.29022 12.913 9.30826 12.9514 9.34108C13.2687 9.61853 13.7203 9.83433 14.083 9.83433C14.1311 9.83433 14.1772 9.85343 14.2112 9.88744C14.2452 9.92145 14.2643 9.96757 14.2643 10.0157V11.2851Z" stroke={color ?? "#71717A"} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default AlertIcon;

